import { render, staticRenderFns } from "./SubCollectivitiesList.vue?vue&type=template&id=1d6cc91e"
import script from "./SubCollectivitiesList.vue?vue&type=script&lang=js"
export * from "./SubCollectivitiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports